define('commons/city-area',['jquery', 'commons/coverage-map', 'commons/message-manager', 'commons/autocomplete', 'async!google-maps'], function($, CoverageMap, message, Autocomplete) {
    var CityArea = function(mapId, data, operatorId) {
        this.cityAreaMap = new CoverageMap(mapId, {
            zoom: 1,
            displayDensity: true,
            displayLandCover: true,
            binUrl: '/baseStation/bin/coverage/' + operatorId,
            clusterer : {
                isDisabled : true,
            },
            fullScreen: 'map-wrapper',
            useTile: data.useTile,
            densityBaseImgUrl: data.geodataBaseImgUrls ? data.geodataBaseImgUrls[data.currentPopulationSet] : "",
            landCoverBaseImgUrl: data.geodataBaseImgUrls ? data.geodataBaseImgUrls[data.currentLandcoverSet] : ""
        });
        this.map = this.cityAreaMap.map;

        // Create autocomplete search field
        var autocomplete = new Autocomplete(".locationSearchInput", this.map);

        var colorBlue = '#86adf1';
        var colorPurple = '#830080';
        var colorOrange = '#ff8c00';

        var options = {
                fillColor: colorBlue,
                fillOpacity: 0.15,
                strokeColor: colorBlue,
                strokeWeight: 1,
                editable: true,
                draggable: true
        };
        var urban = $.extend([], options, {strokeColor: colorPurple, fillColor: colorPurple, zIndex: 10});
        var suburban = $.extend([], options, {strokeColor: colorOrange, fillColor: colorOrange, zIndex: 1});
        
        var drawingOptions = {
                map: this.map,
                drawingMode: null,
                drawingControlOptions: {
                        drawingModes: [google.maps.drawing.OverlayType.CIRCLE, google.maps.drawing.OverlayType.POLYGON],
                        position: google.maps.ControlPosition.TOP_RIGHT
                                },
                circleOptions: options,
                polygonOptions: options
        };

        var drawing = new google.maps.drawing.DrawingManager(drawingOptions);

        // save created circle
        var circles = [];
        var circleIndex = 0;
        var currentCirclePopup = undefined; //Provide a Handle to the unique popup opened in map area
        var currentPolygonPopup = undefined; //Provide a Handle to the unique popup opened in map area

        var fillCircleContent = function(circle, circleIndex, here, deleteButtton) {
            currentCirclePopup = new google.maps.InfoWindow({maxWidth: 300});
            circles[circleIndex] = circle;
            circle.index = circleIndex;
            var content = '<div class="info-container"><h3>Circle details:</h3>' +
            '<p>Name: <input id="circle-complete-name" type="text" value="' + (circle.name ? circle.name : 'circle ' + (circle.index + 1)) + '"/></p>' +
            '<p>Type: <a class="circle-complete-type ' + (circle.type == 'urban' ? 'urban-select' : '') + ' href="javascript:void(0)" ><span class="icon-circle icon-large ' + (circle.type ? circle.type : 'suburban') + '"></span><span class="text"> ' + (circle.type == 'urban' ? 'Urban' : 'Suburban') + '</span></a></p>' +
            '<p>Center lat: <input id="circle-center-lat" type="text" value="' + circle.center.lat() + '"/></p>' +
            '<p>Center lng: <input id="circle-center-lng" type="text" value="' + circle.center.lng() + '"/></p>' +
            '<p>Radius: <input id="circle-radius" type="text" value="' + (Math.round(circle.radius) / 1000) + '"/></p>' +
            '<p><input type="button" class="type-button" data-index="' + circleIndex + '" value="Ok"></p></div>';
            currentCirclePopup.setContent(content);
            currentCirclePopup.setPosition(circle.center);
            currentCirclePopup.open(here.map);
            currentCirclePopup.addListener('domready', function() {
                $(".type-button").click(function(e) {
                    var elem = $(e.currentTarget);
                    var c = circles[elem.data("index")];
                    if (c) {
                        var container = $(".info-container");
                        if (container.find(".circle-complete-type").hasClass("urban-select")) {
                            c.type = "urban";
                        } else {
                            c.type = "suburban";
                        }
                        if (c.type === "urban") {
                            c.setOptions(urban);
                        } else {
                            c.setOptions(suburban);
                        }
                        

                        var centerLat = $("#circle-center-lat").val();
                        var centerLng = $("#circle-center-lng").val();
                        var radius = $("#circle-radius").val();
                        var name = container.find("#circle-complete-name").val().trim();
                        
                        if (validName(name) && validCoord(centerLat, true) && validCoord(centerLng, false) && radius.length > 0 && !isNaN(Number(radius))) {
                            c.name = name;
                            c.setCenter(new google.maps.LatLng(centerLat, centerLng));
                            c.setRadius(radius * 1000);
                        } else {
                            message.error("Circle update error: invalid parameters");
                        }

                    }
                    cleanCircleContext(false);
                });
                $( ".circle-complete-type" ).click(function(e) {
                    var self = $(".circle-complete-type");
                    var isUrban = self.hasClass("urban-select");
                    if (!isUrban) {
                        self.html("<span class='icon-circle icon-large urban'></span><span class='text'> Urban</span>" );
                        self.addClass("urban-select");
                    } else {
                        self.html("<span class='icon-circle icon-large suburban'></span><span class='text'> Suburban</span>" );
                        self.removeClass("urban-select");
                    }
                });

                if (deleteButtton) {
                    var container = $(".info-container");
                    container.append('<p><input type="button" class="delete-button" data-index="' + circleIndex + '" value="Delete"></p>');

                    $(".delete-button").click(function(e) {
                        var elem = $(e.currentTarget);
                        var index = elem.data("index");
                        var c = circles[index];
                        if(c) {
                            c.setMap(null);
                            circles[index] = null;
                        }
                        cleanCircleContext(false);
                    });
                }
            });

            google.maps.event.addListener(currentCirclePopup, "closeclick", $.proxy(function() {
                var circle = circles[circles.length - 1];
                if (circle && !circle.type) {
                    circle.setMap(null);
                    circles[circle.index] = null;
                }
            }, this));

            google.maps.event.addListener(currentCirclePopup, "content_changed", $.proxy(function() {
                var circle = circles[circles.length - 2];
                if (circle && !circle.type) {
                    circle.setMap(null);
                    circles[circle.index] = null;
                }
            }, this));
        };

        var validCoord = function(coord, isLat) {
            return coord.length > 0 && !isNaN(Number(coord)) && ((isLat && coord >= -90 && coord <= 90) || (coord >= -180 && coord <= 180));
        };
        
        var validName = function(name) {
            return name && name.length !== 0;
        };

        var cleanCircleContext = function(deleteCircle) {
            if(currentCirclePopup) {
                if (deleteCircle) { //javascript miracle undefined == false, what if we used ecmascript ?
                    var circle = circles[circles.length - 1];
                    if (circle && !circle.type) {
                        circle.setMap(null);
                        circles[circle.index] = null;
                    }
                }
                currentCirclePopup.close();
                currentCirclePopup = undefined;
            }
        };
        var cleanPolygonContext = function(deletePolygon) {
            if(currentPolygonPopup) {
                if (deletePolygon) { //javascript miracle undefined == false, what if we used ecmascript ?
                    var polygon = polygons[polygons.length - 1];
                    if (polygon && !polygon.type) {
                        polygon.setMap(null);
                        polygons[polygon.index] = null;
                    }
                }
                currentPolygonPopup.close();
                currentPolygonPopup = undefined;
            }
        };

        google.maps.event.addListener(drawing, "circlecomplete", $.proxy(function(circle) {
            cleanCircleContext(true);
            cleanPolygonContext(true);
            fillCircleContent(circle, circleIndex, this);
            google.maps.event.addListener(circle, "rightclick", $.proxy(function(e) {
                cleanCircleContext(true);
                fillCircleContent(circle, circle.index, this, true);
            }, this));
            circleIndex++;
        }, this));

        // save created polygons
        var polygons = [];
        var polygonIndex = 0;

        var fillPolygonContent = function(polygon, polygonIndex, here, deleteButtton) {
            currentPolygonPopup = new google.maps.InfoWindow({maxWidth: 300});
            polygons[polygonIndex] = polygon;
            polygon.index = polygonIndex;
            var content = '<div class="info-container"><h3>Polygon details:</h3>' +
            '<p>Name: <input id="polygon-complete-name" type="text" value="' + (polygon.name ? polygon.name : 'polygon ' + (polygon.index + 1)) + '"></input></p>' +
            '<p>Type: <a class="polygon-complete-type " ' + (polygon.type == 'urban' ? 'urban-select' : '') + ' href="javascript:void(0)" ><span class="icon-circle icon-large ' + (polygon.type ? polygon.type : 'suburban') + '"></span><span class="text"> ' + (polygon.type == 'urban' ? 'Urban' : 'Suburban') + '</span></a></p>' +
            '<p><input type="button" class="type-button" data-index="' + polygonIndex + '" value="Ok"></p></div>';
            currentPolygonPopup.setContent(content);
            currentPolygonPopup.setPosition(polygon.getPath().getAt(0));
            currentPolygonPopup.open(here.map);

            currentPolygonPopup.addListener('domready', function() {
                $(".type-button").click(function(e) {
                    var elem = $(e.currentTarget);
                    var p = polygons[elem.data("index")];
                    if (p) {
                        var container = $(".info-container");
                        if (container.find(".polygon-complete-type").hasClass("urban-select")) {
                            p.type = "urban";
                        } else {
                            p.type = "suburban";
                        }
                        if (p.type === "urban") {
                            p.setOptions(urban);
                        } else {
                            p.setOptions(suburban);
                        }
                        p.name = container.find("#polygon-complete-name").val().trim();
                    }
                    cleanPolygonContext(false);
                });
                
                $( ".polygon-complete-type" ).click(function() {
                    var self = $(".polygon-complete-type");
                    var isUrban = self.hasClass("urban-select");
                    if (!isUrban) {
                        self.html("<span class='icon-circle icon-large urban'></span><span class='text'> Urban</span>" );
                        self.addClass("urban-select");
                    } else {
                        self.html("<span class='icon-circle icon-large suburban'></span><span class='text'> Suburban</span>" );
                        self.removeClass("urban-select");
                    }
                });

                if (deleteButtton) {
                    var container = $(".info-container");
                    container.append('<p><input type="button" class="delete-button" data-index="' + polygonIndex + '" value="Delete"></p>');

                    $(".delete-button").click(function(e) {
                        var elem = $(e.currentTarget);
                        var index = elem.data("index");
                        var c = polygons[index];
                        if(c) {
                            c.setMap(null);
                            polygons[index] = null;
                        }
                        cleanPolygonContext(false);
                    });
                }
            });
            google.maps.event.addListener(currentPolygonPopup, "closeclick", $.proxy(function() {
                var polygon = polygons[polygons.length - 1];
                if (polygon && !polygon.type) {
                    polygon.setMap(null);
                    polygons[polygon.index] = null;
                }
            }, this));

            google.maps.event.addListener(currentPolygonPopup, "content_changed", $.proxy(function() {
                var polygon = polygons[polygons.length - 2];
                if (polygon && !polygon.type) {
                    polygon.setMap(null);
                    polygons[polygon.index] = null;
                }
            }, this));

        };

        google.maps.event.addListener(drawing, "polygoncomplete", $.proxy(function(polygon) {
            cleanCircleContext(true);
            cleanPolygonContext(true);
            fillPolygonContent(polygon, polygonIndex, this, false);
            google.maps.event.addListener(polygon, "rightclick", $.proxy(function(e) {
                cleanPolygonContext(true);
                fillPolygonContent(polygon, polygon.index, this, true);
            }, this));
            polygonIndex++;
        }, this));

        // fill form data
        $("#cityArea").submit(function (event) {
            var delta = 0.01;
            var circlesHash = "";
            var first = true;
            var index;
            var circle;
            for (index = 0; index < circles.length; index++) {
                circle = circles[index];
                if (circle && circle.type) {
                    var bounds = circle.getBounds();
                    var northLatLng = google.maps.geometry.spherical.computeOffset(circle.center, circle.radius, 0);
                    var north = Math.abs(northLatLng.lng() - circle.center.lng()) > delta ? 90 : northLatLng.lat();
                    var southLatLng = google.maps.geometry.spherical.computeOffset(circle.center, circle.radius, 180);
                    var south = Math.abs(southLatLng.lng() - circle.center.lng()) > delta ? -90 : southLatLng.lat();
                    var height = north - south;
                    var eastLatLng = google.maps.geometry.spherical.computeOffset(circle.center, circle.radius, 90);
                    var neLng = eastLatLng.lng();
                    var swLng = circle.center.lng();
                    var width = swLng > neLng ? 2 *(neLng - swLng + 360) : 2 * (neLng - swLng);
                    var type = circle.type;
                    if (type) {
                        if (!first) {
                            circlesHash += ";";
                        } else {
                            first = false;
                        }
                        circlesHash += circle.name + ";" + circle.getCenter().lat() + ";" + circle.getCenter().lng() + ";" + width + ";" + height + ";" + type;
                    }
                }
            }
            $("#circles-hidden").val(circlesHash);

            var polygonsHash = "";
            first = true;
            var polygon;
            for (index = 0; index < polygons.length; index++) {
                polygon = polygons[index];
                if (polygon) {
                    if (!first) {
                        polygonsHash += ";";
                    } else {
                        first = false;
                    }
                    polygonsHash += polygon.name + ";";
                    var firstCoord = true;
                    polygon.getPath().forEach(function (coord) {
                        if (!firstCoord) {
                            polygonsHash += ":";
                        } else {
                            firstCoord = false;
                        }
                        polygonsHash += coord.lat() + ":" + coord.lng();
                    });
                    polygonsHash += ";" + polygon.type;
                }
            }
            $("#polygons-hidden").val(polygonsHash);
        });

        this.drawCircle = function(name, centerLat, centerLng, width, isUrban) {
            var latLngCenter = new google.maps.LatLng(centerLat, centerLng);
            var latLngRight = new google.maps.LatLng(latLngCenter.lat(), latLngCenter.lng() + (width/2));
            var options = {
                map : this.map,
                center : latLngCenter,
                radius : google.maps.geometry.spherical.computeDistanceBetween(latLngCenter, latLngRight)
            };
            var colors;
            if (isUrban) {
                colors = urban;
            } else {
                colors = suburban;
            }
            
            var circle = new google.maps.Circle($.extend([], options, colors));
            circle.index = circleIndex;
            google.maps.event.addListener(circle, "rightclick", $.proxy(function(e) {
                cleanCircleContext(true);
                cleanPolygonContext(true);
                fillCircleContent(circle, circle.index, this, true);
            }, this));
            if (isUrban) {
                circle.type = "urban";
            } else {
                circle.type = "suburban";
            }
            circle.name = name;
            circles[circleIndex] = circle;
            if (circleIndex === 0) {
                this.bounds = circle.getBounds();
            } else {
                this.bounds = this.bounds.union(circle.getBounds());
            }
            circleIndex++;
        };

        var polygonBounds = function(polygon) {
            var latLng;
            var bounds;
            var path = polygon.getPath();
            for (k = 0; k < path.getLength(); k ++) {
                latLng = new google.maps.LatLng(path.getAt(k).lat(), path.getAt(k).lng());
                if (k === 0) {
                    bounds = new google.maps.LatLngBounds(latLng, latLng);
                } else {
                    bounds = bounds.extend(latLng);
                }
            }
            return bounds;
        };

        this.drawPolygon = function(name, coords, isUrban) {
            var paths = [];
            for (k = 0; k < coords.length; k++) {
                paths[k] = new google.maps.LatLng(coords[k].lat, coords[k].lng);
            }
            var options = {
                map: this.map,
                paths : paths
            };
            var colors;
            if (isUrban) {
                colors = urban;
            } else {
                colors = suburban;
            }
            var polygon = new google.maps.Polygon($.extend([], options, colors));
            polygon.index = polygonIndex;
            google.maps.event.addListener(polygon, "rightclick", $.proxy(function(e) {
                cleanCircleContext(true);
                cleanPolygonContext(true);
                fillPolygonContent(polygon, polygon.index, this, true);
            }, this));
            if (isUrban) {
                polygon.type = "urban";
            } else {
                polygon.type = "suburban";
            }
            polygon.name = name;
            polygons[polygonIndex] = polygon;
            if (!this.bounds) {
                this.bounds = polygonBounds(polygon);
            } else {
                this.bounds = this.bounds.union(polygonBounds(polygon));
            }
            polygonIndex++;
        };
        
        for(var i = 0; i < data.circles.length; i++) {
            var circle = data.circles[i];
            this.drawCircle(circle.name, circle.center.lat, circle.center.lng, circle.width, circle.urban);
        }

        for(var j = 0; j < data.polygons.length; j++) {
            var polygon = data.polygons[j];
            this.drawPolygon(polygon.name, polygon.coords, polygon.urban);
        }
        
        if(this.bounds) {
            this.map.fitBounds(this.bounds);
        }
    };

    CityArea.prototype.addCircle = function(name, centerLat, centerLng, width, isUrban) {
        if(centerLat && centerLng && width){
            var latLngCenter = new google.maps.LatLng(centerLat, centerLng);
            var latLngRight = google.maps.geometry.spherical.computeOffset(latLngCenter, width * 1000, 90);
            this.drawCircle(name, centerLat, centerLng, Math.abs(latLngCenter.lng() - latLngRight.lng()), isUrban);
            this.map.fitBounds(this.bounds);
        }
    };

    CityArea.prototype.addPolygonPoints = function(name, pointLat, pointLng, isUrban) {
        var coords = [];
        for(var i = 0; i < pointLat.length; i++) {
            coords[i] = {lat: pointLat[i], lng: pointLng[i]};
        }
        this.drawPolygon(name, coords, isUrban);
        this.map.fitBounds(this.bounds);
    };

    CityArea.prototype.addPolygon = function(name, points,isUrban) {
        var coords = [];
        for(var i = 0; i < points.length; i++) {
            if(points[i].lat && points[i].lng){
                coords[i] = {lat: points[i].lat, lng: points[i].lng};
            }
        }
        this.drawPolygon(name, coords, isUrban);
        this.map.fitBounds(this.bounds);
    };

    return CityArea;
});
